<template>
	<div class="countdown-box rounded">
		<countdown :time="countdownTime" :transform="transformCountdown">
			<template slot-scope="props"
				>Your {{ discount }}% Discount Code has been applied!
				<span v-if="countdown.timerEnabled === true"
					>Your code will expire in:
					<span class="countdown-time"
						>{{ props.hours }}:{{ props.minutes }}:{{
							props.seconds
						}}</span
					>.</span
				>
				<p class="m-0">Please do not leave this page!</p></template
			>
		</countdown>
	</div>
</template>

<script>
import Countdown from "@chenfengyuan/vue-countdown"

export default {
	components: {
		Countdown,
	},
	props: {
		countdown: {
			type: Object,
			default: () => {},
		},
		discount: {
			type: Number,
			default: 0,
		},
	},
	computed: {
		countdownTime() {
			let c = this.countdown.time
			return (
				(c.days * 86400 + c.hours * 3600 + c.mins * 60 + c.secs) * 1000
			)
		},
	},
	methods: {
		transformCountdown(props) {
			Object.entries(props).forEach(([key, value]) => {
				// Adds leading zero
				const digits = value < 10 ? `0${value}` : value

				props[key] = `${digits}`
			})

			return props
		},
	},
}
</script>

<style lang="scss" scoped>
</style>